
const CrewManagementReducer = (state = {}, action) => {
    switch (action.type) {
        case "getSearchCrewSuccess": {
            return Object.assign({}, state, {
                SearchCrew: action.data,
            });
            break;
        }
     

        case "getshipnameSuccess": {
            return Object.assign({}, state, {
                GetShipName: action.data,
            });
            break;
        }
        case "getCrewDetailsSuccess": {
            return Object.assign({}, state, {
                CrewDetails: action.data,
            });
            break;
        }
        case "getPhotoSuccess": {
            return Object.assign({}, state, {
                GetPhoto: action.data,
            });
            break;
        }
        case "getCrewPhotoSuccess": {
            return Object.assign({}, state, {
                GetCrewPhoto: action.data,
            });
            break;
        }
        case "getCrewDetailsFailure": {
            return Object.assign({}, state, {
                CrewDetails: action.data,
            });
            break;
        }
        case "postAddCrewSuccess": {
            return Object.assign({}, state, {
                AddCrew: action.data,
            });
            break;
        }
        case "postAddCrewFailure": {
            return Object.assign({}, state, {
                AddCrew: action.data,
            });
            break;
        }
        case "putUpdateCrewSuccess": {
            return Object.assign({}, state, {
                UpdateCrew: action.data,
            });
            break;
        }
        case "putUpdateCrewFailure": {
            return Object.assign({}, state, {
                UpdateCrew: action.data,
            });
            break;
        }
        default: {
            return state;
        }
    }
};
export default CrewManagementReducer;
